import axios from 'axios'

export const UserApi = {
    async Table(data){
        const response = await axios.post('/api/user/table',data)
        return response
    },
    async List(){
        const response = await axios.post('/api/user/list')
        return response
    },
    async CustomerList(){
        const response = await axios.get('/api/user/list?isCustomer=true')
        return response
    },
    async SalesmanList(){
        const response = await axios.get('/api/user/list/salesman')
        return response
    },
    async CreateOrUpdate(update,data){
        const response = await axios.post(update ? '/api/user/update' : '/api/user/create' , data)
        return response
    },
    async Delete(data){
        const response = await axios.post(`/api/user/delete/${data}`)
        return response
    },
    async Disable(data){
        const response = await axios.post(`/api/user/disable/${data}`)
        return response
    },
    async ResendConfirmationCode(data){
        const response = await axios.post(`/api/user/resendconfirmationcode/${data}`)
        return response
    },
    async Confirm(code){
        const response = await axios.post(`/api/user/confirm/${code}`)
        return response
    },
    async UpdatePassword(data){
        const response = await axios.post('/api/user/update/password',data)
        return response
    },
    async CurrentUserProfile(){
        const response = await axios.get(`/api/user/currentuserinformation`)
        return response
    },
    async CreateCustomer(data){
        const response = await axios.post(`/api/user/customer/create`,data)
        return response
    },
    async ConfirmCustomerUser(id,code){
        const response = await axios.post(`/api/user/confirmcustomeruser/${id}/${code}`)
        return response
    },
    async ResendCustomerUserConfirmationCode(id){
        const response = await axios.post(`/api/user/resendcustomeruserconfirmationcode/${id}`)
        return response
    },
    async NotifyClassification(){
        const response = await axios.get(`/api/user/get/notifyclassification/list`)
        return response
    },
    async UpdateNotifyClassificationOfUser(data){
        const response = await axios.post(`/api/user/update/notifyclassificationofuser`,data)
        return response
    },
    async NotifyClassificationOfUser(id){
        const response = await axios.get(`/api/user/get/notifyclassificationofuser/list/${id}`)
        return response
    }
}